import { defineStore } from "pinia";
import { ref } from "vue";
import { News } from "@/contracts/Articles";

export const useRouteStore = defineStore("route", () => {
  const id = ref(0);
  const itemId = ref(0);
  const type = ref("default" as string);

  const setId = (params: any) => {
    id.value =
      typeof params["categoryId"] === "undefined"
        ? 0
        : parseInt(params["categoryId"]);
  };

  const setItemId = (params: any) => {
    itemId.value =
      typeof params["itemId"] === "undefined" ? 0 : parseInt(params["itemId"]);
  };

  const setTypePage = (params: any) => {
    type.value =
      typeof params["type"] === "undefined" ? "default" : params["type"];
  };
  const getId = (): number => id.value;
  const getItemId = (): number => itemId.value;
  const getType = (): string => type.value;

  const setRouteParams = (params: any) => {
    setItemId(params);
    setId(params);
    setTypePage(params);
  };

  return {
    id,
    itemId,
    type,
    setId,
    getId,
    getType,
    getItemId,
    setItemId,
    setTypePage,
    setRouteParams,
  };
});
